"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var consts_1 = require("../utils/consts");
var load_more_1 = require("../features/load-more");
function init() {
    if (document.getElementById('ldt-reports-container')) {
        (0, load_more_1.initialize_load_more)('ldt-reports', {
            // parameter
            date_from: (Math.trunc(Date.now() / 1000)) - 28 * consts_1.seconds_in_a_day,
            page: 1,
            per_page: 20,
        }).catch(function (e) { return console.error(e); });
    }
}
exports.init = init;
